import * as _ from 'lodash-es';
import { getSourceUrlWithAssetToken } from '../../AssetTokenContext';
import getDownloadLink from '../../utils/getDownloadLink';
import type { AttachmentFile } from '../Attachment';

export const convertAttachmentToHtmlLink = (
  attachment: AttachmentFile,
  assetToken: string | null,
) => {
  const downloadLink = getDownloadLink(attachment);
  const urlWithJWT =
    downloadLink && assetToken
      ? getSourceUrlWithAssetToken(downloadLink, assetToken)
      : attachment.source;
  return `<a href="${urlWithJWT}" data-attachment-size="${attachment.size}" data-source="${attachment.source}">${_.escape(attachment.name)}</a>`;
};

export const convertAttachmentsToHtmlList = (
  attachments: AttachmentFile[],
  assetToken: string | null,
) => {
  const items = attachments.map((attachment) => {
    return `<li>${convertAttachmentToHtmlLink(attachment, assetToken)}</li>`;
  });
  return `<ul>${items.join('')}</ul>`;
};

export const parseAttachmentsHtml = (node: HTMLElement) => {
  return [...node.querySelectorAll('a')]
    .map((el) => ({
      name: el.innerText.trim(),
      size: parseInt(el.getAttribute('data-attachment-size') ?? '', 10),
      urlWithJWT: el.getAttribute('href') ?? '',
      urlWithoutJWT: el.getAttribute('data-source') ?? '',
    }))
    .filter((el) => el.urlWithJWT && el.urlWithoutJWT && el.name && el.size);
};
